exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-danger[data-v-298ac204]{border:3px solid #da4453!important}.inputfile[data-v-298ac204]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}#file_loader2[data-v-298ac204],#file_loader[data-v-298ac204]{margin:0;padding:0;cursor:pointer}.col-xs-4[data-v-298ac204]{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-298ac204","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Tasks.vue
// module id = 338
// module chunks = 0